import { render, staticRenderFns } from "./user-msg.vue?vue&type=template&id=b7fcd6dc&scoped=true&"
import script from "./user-msg.vue?vue&type=script&lang=js&"
export * from "./user-msg.vue?vue&type=script&lang=js&"
import style0 from "./user-msg.vue?vue&type=style&index=0&id=b7fcd6dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fcd6dc",
  null
  
)

export default component.exports